// extracted by mini-css-extract-plugin
export default {"header":"Parts_header__myg1d","search":"Parts_search__7pIDv","card":"Parts_card__WKmxl"};